var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquipmentIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7132 36.8359L21.0703 36.8359",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2485 12.375H31.2491C38.3328 12.375 39.0411 15.6876 39.5203 19.7295L41.3954 35.3551C41.9996 40.4803 40.4162 44.668 33.1242 44.668H14.3943C7.08148 44.668 5.49808 40.4803 6.1231 35.3551L7.9982 19.7295C8.45655 15.6876 9.16489 12.375 16.2485 12.375Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 15.5V8.20833C15.4141 5.08333 17.4974 3 20.6224 3H26.8724C29.9974 3 32.0807 5.08333 32.0807 8.20833V15.5",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7129 35.4453L13.0332 35.4453",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.998 24.7266C29.998 25.2266 29.9356 25.7109 29.8106 26.1797C29.6699 26.8047 29.4199 27.4141 29.0918 27.9453C28.0137 29.7578 26.0293 30.9766 23.748 30.9766C22.1387 30.9766 20.6855 30.3671 19.5918 29.3671C19.123 28.9609 18.7168 28.4766 18.4043 27.9453C17.8262 27.0078 17.498 25.8984 17.498 24.7266C17.498 23.0391 18.1699 21.4922 19.2637 20.3672C20.4043 19.1953 21.998 18.4766 23.748 18.4766C25.5918 18.4766 27.2637 19.2735 28.3887 20.5547C29.3887 21.6641 29.998 23.1328 29.998 24.7266Z",
    fill: "#A020FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.08 24.6992H21.4238",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.752 22.4141V27.0859",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentIcon1);
export default __webpack_public_path__ + "static/media/equipmentIcon1.204b8b3f488a4836cf60fd3629c37104.svg";
export { ForwardRef as ReactComponent };